<template src="./FormStep1.html"></template>
<style lang="scss" src="./FormStep1.scss"></style>
<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
    name: 'FormStep1',

    data () {
        return {
            errors: [],
            values: {
                Email: '',
                EmailRepeat: '',
                Nome: '',
                Cog_RagSoc: '',
                Privacy: false,
                Tel: '',
                Cell: '',

                // hidden fields
                Tensione: '',
                Prodotto: '',
                Tipo_Processo: '',
                Campagna: '',
                Tipo_Ana: '',
                Ene_Rinn: '',
                Tservizio: '',
                Ttariffa: ''
            }
        }
    },

    computed: {
        extraParams() {
            return this.$store.state.extraParams
        },

        form() {
            return this.$store.state.form
        },

        formValues() {
            return this.$store.state.form.values
        },

        strings() {
            return this.$store.state.strings
        },

        svg() {
            return this.$store.state.svg
        },

        token() {
            return this.$store.state.token
        }
    },

    watch: {
        formValues() {
            this.$updateValuesFromStore()
        },

        'values.Privacy'(value) {
            // update store value in real time
            this.$store.commit('formValues', { Privacy: value })
        }
    },

    mounted() {
        this.$updateValuesFromStore()

        Vue.nextTick().then(() => {
            if (this.$refs.emailField) {
                const input = this.$refs.emailField.$el.querySelector("input")
                if (input) {
                    input.addEventListener('copy', this.onCopyPaste)
                    input.addEventListener('paste', this.onCopyPaste)
                    input.addEventListener('drop', this.onCopyPaste)
                    input.addEventListener('cut', this.onCopyPaste)
                }
            }
            if (this.$refs.emailFieldRepeat) {
                const input = this.$refs.emailFieldRepeat.$el.querySelector("input")
                if (input) {
                    input.addEventListener('copy', this.onCopyPaste)
                    input.addEventListener('paste', this.onCopyPaste)
                    input.addEventListener('drop', this.onCopyPaste)
                    input.addEventListener('cut', this.onCopyPaste)
                }
            }
        })
    },

    methods: {
        onCopyPaste(e) {
            e.preventDefault()
            return false
        },

        submit() {
            this.validation()
            if (this.token && !this.errors.length) {
                let data = {
                    tokenId: this.token,
                    step: 1,
                    fields: _.map(this.values, (valueField, field) => ({
                        field,
                        valueField : valueField === null ? '' : valueField
                    }))
                }

                // add UserRv
                data.fields.push({
                    field: 'userRv',
                    valueField: this.form.values.UserRv
                })

                // append get params to data
                _.each(this.extraParams, (valueField, field) => {
                      data.fields.push({
                          field,
                          valueField
                      })
                })

                const formData = new FormData()
                formData.append('data', JSON.stringify(data))

                // console.log(formData.get('data'))

                this.$apiCall('/StepFunnelWeb/AddDataStepFunnel', {
                    method: 'POST',
                    body: formData
                }).then(data => {
                    if (data && data.status && data.status === 200) {
                        this.$store.commit('formValues', this.values)
                        this.$store.commit('formIndex', 1)
                    } else {
                        alert("Si sono verificati degli errori")
                    }
                })
            }
        },

        validation() {
            const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
            const numericRegex = /^\d+$/
            let fields = []

            this.errors = []

            if (['ee-dom', 'gas-dom'].includes(this.form.type)) {
                fields = ['Nome', 'Cog_RagSoc', 'Privacy', 'Email', 'EmailRepeat', 'Cell']
            }

            if (['ee-au', 'gas-au'].includes(this.form.type)) {
                fields = ['Cog_RagSoc', 'Privacy', 'Email', 'EmailRepeat', 'Tel', 'Cell']
            }

            fields.forEach(field => {
                if (field === 'Email' && !this.values.Email.match(emailRegex)) {
                    this.errors.push('Email')
                }

                if (field === 'EmailRepeat' && (!this.values.Email || this.values.Email !== this.values.EmailRepeat)) {
                    this.errors.push('EmailRepeat')
                }

                if (field === 'Nome' && !this.values.Nome) {
                    this.errors.push('Nome')
                }

                if (field === 'Cog_RagSoc' && !this.values.Cog_RagSoc) {
                    this.errors.push('Cog_RagSoc')
                }

                if (field === 'Privacy' && !this.values.Privacy) {
                    this.errors.push('Privacy')
                }

                if (field === 'Tel' && (this.values.Tel.length < 6 || !this.values.Tel.match(numericRegex))) {
                    if (['ee-au', 'gas-au'].includes(this.form.type)) {
                        // if cell non valid trigger error for Tel also
                        if (this.values.Cell.length < 6 || !this.values.Cell.match(numericRegex)) {
                            this.errors.push('Tel')
                        }
                    } else {
                        this.errors.push('Tel')
                    }
                }

                if (field === 'Cell' && (this.values.Cell.length < 6 || !this.values.Cell.match(numericRegex))) {
                    if (['ee-au', 'gas-au'].includes(this.form.type)) {
                        // if Tel non valid trigger error for Tel also
                        if (this.values.Tel.length < 6 || !this.values.Tel.match(numericRegex)) {
                            this.errors.push('Cell')
                        }
                    } else {
                        this.errors.push('Cell')
                    }
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/FormStep1/FormStep1.vue